import { call, put, takeEvery, takeLatest, delay } from "redux-saga/effects"
import { sendWhatsAppMsgAPI } from "./api";
import { sendWhatsAppMsgFailed, sendWhatsAppMsgSuccess } from "./actions";
import { SEND_WHATSAPP_MSG } from "./constants";


function* adminGetNdaAgreementAsync(action) {
    try {
        const response = yield call(sendWhatsAppMsgAPI, action.payload)
        if (response && response.status === 200) {
            yield put(sendWhatsAppMsgSuccess(response?.data?.message || "Message sent Successfully"))
        } else {
            throw response;
        }

    } catch (error) {
        console.log("error", error)
        yield put(sendWhatsAppMsgFailed(error?.response?.data?.error || "Unable to Send Message"))
    }
}


function* sendWhatsAppMsgSaga() {
    yield takeEvery(SEND_WHATSAPP_MSG, adminGetNdaAgreementAsync)
}

export default sendWhatsAppMsgSaga;